import CrudRepository from './CrudRepository'
export default class PressReleasesCardDetails extends CrudRepository {
  constructor () {
    super('customerCare/api/news')
  }
}
